import { defaultsConfig } from "~config/sport/defaults";
import { Disciplines } from "~enums/disciplines";
import { PeriodTypes } from "~enums/periodTypes.ts";
import type { SportConfiguration } from "~types/sportConfiguration";

export const volleyballConfig: SportConfiguration = {
  ...defaultsConfig,
  disciplines: [Disciplines.Indoor, Disciplines.Beach],
  periods: {
    [PeriodTypes.Period1]: { intlKey: "period.period1" },
    [PeriodTypes.Period2]: { intlKey: "period.period2" },
    [PeriodTypes.Period3]: { intlKey: "period.period3" },
    [PeriodTypes.Period4]: { intlKey: "period.period4" },
    [PeriodTypes.ExtraPeriod0]: { intlKey: "period.overtime1" },
    [PeriodTypes.ExtraPeriod1]: { intlKey: "period.overtime2" },
    [PeriodTypes.ExtraPeriod2]: { intlKey: "period.overtime3" },
    [PeriodTypes.ExtraPeriod3]: { intlKey: "period.overtime4" },
    [PeriodTypes.ExtraPeriod4]: { intlKey: "period.overtime5" },
    [PeriodTypes.ExtraPeriod5]: { intlKey: "period.overtime6" },
  },
};
